import React, { useState } from "react";
import SignatureFormatter from "./components/SignatureFormatter";
import "./style.css";

const Wrapper = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const Container = {
  width: "100%",
  display: "block",
};
const InputWrapper = {
  margin: "0 0",
  paddingTop: "20px",
};
const leftPart = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%"
}
const inputWrapper = {
  display: "flex",
  flexDirection: "row",
  gap: "15px"
}

// default data to print
const userData = {
  firstname: "Alexandra",
  lastname: "MOUGIN",
  urlImage: "",
  job: "Avocate",
  phone: "03 84 21 94 10",
  postalAdressTitle: "Barreau de Belfort",
  postalAdressStreet: "1 Rue Morimont",
  postalAdressCity: "90000 BELFORT",
  postalAdressTitle2: "Barreau de Montbéliard",
  postalAdressStreet2: "8 Rue du Grand Crot",
  postalAdressCity2: "25140 CHARQUEMONT",
  website: "www.nouvel-air.fr",
  linkedin: "linkedin.com",
  meetlaw: "https://www.meetlaw.fr/annuaire?frmAnnuaire_pageid=0&frmAnnuaire_departement=&frmAnnuaire_ville=&frmAnnuaire_nomavocat=mougin&frmAnnuaire_domaine=218&frmAnnuaire_ok="
};

export default function App() {
  const [user, setUser] = useState(userData);
  const [isChecked, setIsChecked] = useState(false);
  const [typeImage, setTypeImage] = useState('static');

  console.log(user);


  const handleOnChange = e => {
    const { name, value } = e.target;
    setIsChecked(!isChecked);
  };

  const userInfoChange = e => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  function copyToClipboard() {
    let tableToCopy = document.querySelector('.wrapper-table')
    let range = document.createRange();
    range.selectNode(tableToCopy);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }

  function responseCopy() {
    let button = document.querySelector('button');
      button.classList.add('copied');
    setTimeout(() => {
      button.classList.remove('copied');
    }, 2000);
  }

  return (
    <div style={Wrapper}>
      <div style={Container}>
        <section className="formulaire">
          <div style={leftPart}>
            <SignatureFormatter user={user} message={isChecked} typeImage={typeImage} />
          </div>
          <div className="rightPart">
            <h1 className="title">Signature Generator</h1>
            <h2 className="title">By my client is rich</h2>
            <p className="inputLabel">Noms</p>

            {/* INPUT RIGHT SIDE  */}

            {/* ***************          NOM ET PRENOM        *************** */}
            <div style={inputWrapper}>
              <input
                name="lastname"
                onChange={userInfoChange}
                value={user.lastname}
                placeholder="Nom"
                onBlur={() => {
                  user.lastname === "" ? setUser({ ...user, lastname: userData.lastname }) : setUser({ ...user, lastname: user.lastname });
                }}
                onFocus={() => {
                  user.lastname === userData.lastname ? setUser({ ...user, lastname: "" }) : setUser({ ...user, lastname: user.lastname });
                }}
              />
              <input
                name="firstname"
                onChange={userInfoChange}
                value={user.firstname}
                placeholder="Prénom"
                onBlur={() => {
                  user.firstname === "" ? setUser({ ...user, firstname: userData.firstname }) : setUser({ ...user, firstname: user.firstname });
                }}
                onFocus={() => {
                  user.firstname === userData.firstname ? setUser({ ...user, firstname: "" }) : setUser({ ...user, firstname: user.firstname });
                }}
              />
            </div>

            {/* ***************          TITRE DU POSTE        *************** */}
            <div style={InputWrapper}>
              <input
                name="job"
                onChange={userInfoChange}
                value={user.job}
                placeholder="Titre du poste"
                onBlur={() => {
                  user.job === "" ? setUser({ ...user, job: userData.job }) : setUser({ ...user, job: user.job });
                }}
                onFocus={() => {
                  user.job === userData.job ? setUser({ ...user, job: "" }) : setUser({ ...user, job: user.job });
                }}
                />
            </div>
              <p className="inputLabel">Adresse 1</p>

                        {/* ***************          ADRESSE POSTALE        *************** */}
              <div style={InputWrapper}>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdressTitle}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdressTitle === "" ? setUser({ ...user, postalAdressTitle: userData.postalAdressTitle }) : setUser({ ...user, postalAdressTitle: user.postalAdressTitle });
                }}
                onFocus={() => {
                  user.postalAdressTitle === userData.postalAdressTitle ? setUser({ ...user, postalAdressTitle: "" }) : setUser({ ...user, postalAdressTitle: user.postalAdressTitle });
                }}
              />
            </div>
            <div style={InputWrapper}>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdressStreet}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdressStreet === "" ? setUser({ ...user, postalAdressStreet: userData.postalAdressStreet }) : setUser({ ...user, postalAdressStreet: user.postalAdressStreet });
                }}
                onFocus={() => {
                  user.postalAdressStreet === userData.postalAdressStreet ? setUser({ ...user, postalAdressStreet: "" }) : setUser({ ...user, postalAdressStreet: user.postalAdressStreet });
                }}
              />
            </div>

            <div style={InputWrapper}>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdressCity}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdressCity === "" ? setUser({ ...user, postalAdressCity: userData.postalAdressCity }) : setUser({ ...user, postalAdressCity: user.postalAdressCity });
                }}
                onFocus={() => {
                  user.postalAdressCity === userData.postalAdressCity ? setUser({ ...user, postalAdressCity: "" }) : setUser({ ...user, postalAdressCity: user.postalAdressCity });
                }}
              />
            </div>


            <p className="inputLabel">Adresse 2</p>

            <div style={InputWrapper}>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdressTitle2}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdressTitle2 === "" ? setUser({ ...user, postalAdressTitle2: userData.postalAdressTitle2 }) : setUser({ ...user, postalAdressTitle2: user.postalAdressTitle2 });
                }}
                onFocus={() => {
                  user.postalAdressTitle2 === userData.postalAdressTitle2 ? setUser({ ...user, postalAdressTitle2: "" }) : setUser({ ...user, postalAdressTitle2: user.postalAdressTitle2 });
                }}
              />
            </div>
            <div style={InputWrapper}>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdressStreet2}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdressStreet2 === "" ? setUser({ ...user, postalAdressStreet2: userData.postalAdressStreet2 }) : setUser({ ...user, postalAdressStreet2: user.postalAdressStreet2 });
                }}
                onFocus={() => {
                  user.postalAdressStreet2 === userData.postalAdressStreet2 ? setUser({ ...user, postalAdressStreet2: "" }) : setUser({ ...user, postalAdressStreet2: user.postalAdressStreet2 });
                }}
              />
            </div>

            <div style={InputWrapper}>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdressCity2}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdressCity2 === "" ? setUser({ ...user, postalAdressCity2: userData.postalAdressCity2 }) : setUser({ ...user, postalAdressCity2: user.postalAdressCity2 });
                }}
                onFocus={() => {
                  user.postalAdressCity2 === userData.postalAdressCity2 ? setUser({ ...user, postalAdressCity2: "" }) : setUser({ ...user, postalAdressCity2: user.postalAdressCity });
                }}
              />
            </div>

            <p className="inputLabel">Coordonnées</p>

            {/* ***************          TELEPHONE        *************** */}
            <div style={InputWrapper}>
              <input
                name="phone"
                onChange={userInfoChange}
                value={user.phone}
                placeholder="Téléphone"
                onBlur={() => {
                  user.phone === "" ? setUser({ ...user, phone: userData.phone }) : setUser({ ...user, phone: user.phone });
                }}
                onFocus={() => {
                  user.phone === userData.phone ? setUser({ ...user, phone: "" }) : setUser({ ...user, phone: user.phone });
                }}
              />
            </div>


            {/* ***************          SITE INTERNET        *************** */}
            <p className="inputLabel">Site internet</p>
            <div style={InputWrapper}>
              <input
                name="website"
                onChange={userInfoChange}
                value={user.website}
                placeholder="Site internet"
                onBlur={() => {
                  user.website === "" ? setUser({ ...user, website: userData.website }) : setUser({ ...user, website: user.website });
                }}
                onFocus={() => {
                  user.website === userData.website ? setUser({ ...user, website: "" }) : setUser({ ...user, website: user.website });
                }}
              />
            </div>

            {/* ***************          RESEAUX SOCIAUX        *************** */}
            <p className="inputLabel">Social</p>
            {/* ***************          LINKEDIN        *************** */}
            <div style={InputWrapper}>
              <input
                name="linkedin"
                onChange={userInfoChange}
                value={user.linkedin}
                placeholder="Linkedin"
                onBlur={() => {
                  user.linkedin === "" ? setUser({ ...user, linkedin: userData.linkedin }) : setUser({ ...user, linkedin: user.linkedin });
                }}
                onFocus={() => {
                  user.linkedin === userData.linkedin ? setUser({ ...user, linkedin: "" }) : setUser({ ...user, linkedin: user.linkedin });
                }}
              />
            </div>
            <p className="inputLabel">Meetlaw (Pris de RDV)</p>
            {/* ***************          Meetlaw        *************** */}
            <div style={InputWrapper}>
              <input
                name="meetlaw"
                onChange={userInfoChange}
                value={user.meetlaw}
                placeholder="Meetlaw"
                onBlur={() => {
                  user.meetlaw === "" ? setUser({ ...user, meetlaw: userData.meetlaw }) : setUser({ ...user, meetlaw: user.meetlaw });
                }}
                onFocus={() => {
                  user.meetlaw === userData.meetlaw ? setUser({ ...user, meetlaw: "" }) : setUser({ ...user, meetlaw: user.meetlaw });
                }}
              />
            </div>
            <button
              className="copyButton"
              onClick={() => {
                copyToClipboard();
                responseCopy();
              }}
            >
              <p className="btnCopy"></p>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
